/* unplugin-vue-components disabled */import { render } from "./Organization.vue.js?vue&type=template&id=c28a0227!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Organization.vue?vue&type=template&id=c28a0227"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__